import * as React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { AuthenticationContext } from "../Context";
import { useHistory } from "react-router-dom";
import { checkPrivileges } from "../utils/PrivilegesHelper";
import { PrivilegesContext } from "../PrivilegesContext";
import { useCustomerPermission } from "../hooks/useCustomerPermission";

const SettingsIndex: React.FC = () => {
  const { currentUser, ..._ } = React.useContext(AuthenticationContext);
  const history = useHistory();

  const userPrivileges = React.useContext(PrivilegesContext);
  const { permitted: useBillingPermitted } =
    useCustomerPermission("Billing Access");

  const settingsMenus = [
    {
      title: "Actions & Programs",
      description:
        "Configure and manage your care workflows. Build custom actions, organize them in queues, and design programs that guide patients through their care journey.",
      url: "actions-and-programs",
      enabled: true,
      showDisabled: true,
    },
    {
      title: "Builder Tools",
      description:
        "Create and customize the building blocks of your system (encounter templates, facility details, and patient questionnaires) to match your organization’s workflow.",
      url: "builder-tools",
      enabled: true,
      showDisabled: true,
    },
    {
      title: "Catalog",
      description:
        "Manage the centralized library of PDFs, videos, and external links available for use across actions and programs.",
      url: "resource-catalog",
      enabled: checkPrivileges(userPrivileges, "Access Resource Catalog"),
      showDisabled: true,
    },
    {
      title: "Claim Builder Settings",
      description:
        "Set up and maintain claim templates and pricing tables to ensure accurate billing and streamlined claim creation.",
      url: "claim-builder",
      enabled:
        useBillingPermitted &&
        (checkPrivileges(userPrivileges, "Access Claim Template Builder") ||
          checkPrivileges(userPrivileges, "Access Pricing Table")),
      showDisabled: true,
    },
    {
      title: "Data Tools",
      description:
        "Access Data Smasher and bulk upload features to clean, merge, and import large sets of data quickly and accurately.",
      url: "data-tools",
      enabled:
        checkPrivileges(userPrivileges, "Bulk Patient Upload") ||
        checkPrivileges(userPrivileges, "Access NDM Reporting"),
      showDisabled: true,
    },
    {
      title: "Login Page Settings",
      description:
        "Customize the Starfield login experience with customizing options for users accessing the system.",
      url: "login-page-content",
      enabled: checkPrivileges(
        userPrivileges,
        "Enable Login Page Content Management"
      ),
      showDisabled: false,
    },
    {
      title: "Provider & Organization Settings",
      description:
        "Manage provider profiles, organization-level settings, and permissions to keep your directory accurate and up to date.",
      url: "providers-and-organizations",
      enabled: true,
      showDisabled: true,
    },
    {
      title: "Reports",
      description:
        "Configure and access reporting tools to track performance, monitor outcomes, and make data-driven decisions.",
      url: "reports",
      enabled: checkPrivileges(userPrivileges, "Access Reporting"),
      showDisabled: true,
    },
  ];

  const handleRouteNavigation = (route) => {
    history.push(`/${route}`);
  };

  return (
    <div className="settings-index-container">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="container"
      >
        <Grid item xs={12} md={12}>
          <div className="userAdminInformation">
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="stretch"
              className="adminHeader"
            >
              <Grid item xs={12} md={6}>
                <h3>Settings</h3>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="divider"></div>
        </Grid>

        <div className="settings-inner-container">
          <Grid container spacing={3}>
            {settingsMenus.map((settingsMenu, index) => {
              if (settingsMenu.enabled) {
                return (
                  <Grid item xs={12} sm={6} md={4} key={index + 1}>
                    <Card
                      className="item-card"
                      onClick={() => handleRouteNavigation(settingsMenu.url)}
                    >
                      <CardContent className="card-content">
                        <Typography className="card-title">
                          {settingsMenu.title}
                        </Typography>
                        <Typography className="card-description">
                          {settingsMenu.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              }

              if (!settingsMenu.enabled && settingsMenu.showDisabled) {
                return (
                  <Grid item xs={12} sm={6} md={4} key={index + 1}>
                    <Card className="item-card-disabled">
                      <CardContent className="card-content">
                        <Typography className="card-title-disabled">
                          {settingsMenu.title}
                        </Typography>
                        <Typography className="card-description-disabled">
                          {settingsMenu.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              }

              return null;
            })}
          </Grid>
        </div>
      </Grid>
    </div>
  );
};

export default SettingsIndex;
